import { CLIENT, SERVER } from '@shared/ui/data-table';
import { useMemo } from 'react';

export const usePagination = ({
  paginationMode,
  totalPage,
  rowCount,
  pageSize,
  page,
  onPageChange,
}: {
  paginationMode: typeof CLIENT | typeof SERVER;
  totalPage?: number;
  rowCount?: number;
  pageSize?: number;
  page?: number;
  onPageChange?: (page: number) => void;
}) => {
  const pageCount = useMemo(() => {
    if (paginationMode === SERVER) return totalPage || 1;
    if (!rowCount || !pageSize) return totalPage || 1;
    return Math.ceil(rowCount / pageSize);
  }, [paginationMode, totalPage, rowCount, pageSize]);

  const handlePrevPage = () => {
    if (!page || page === 1) return;
    onPageChange?.(page - 1);
  };

  const handleNextPage = () => {
    if (!page || page === pageCount) return;
    onPageChange?.(page + 1);
  };

  return { pageCount, handlePrevPage, handleNextPage };
};
